export const getHighlightsLabel = (accountName: string): string => (accountName.toLowerCase().includes('sky') ? 'Recap' : 'Key Plays');
